import React from 'react';
import { IncludedTax } from '@kouto/cart-prices';
import { CalculationRow } from 'features/ShoppingCart/components/CartSummary/styles';
import { useTranslation } from 'react-i18next';

interface IncludedTaxesProps {
  includedTaxes: IncludedTax[];
}

const IncludedTaxes = ({ includedTaxes }: IncludedTaxesProps) => {
  const { t: translate } = useTranslation();

  if (includedTaxes.length === 0) {
    return null;
  }

  return (
    <CalculationRow
      isOmitted
      className="cart-summary-included-taxes"
      style={{ marginTop: '8px' }}
    >
      *{translate('includes')}{' '}
      {includedTaxes
        .map((t) => `${t.name} (${t.percentage}%)`)
        .join(` ${translate('and')} `)}
    </CalculationRow>
  );
};

export default IncludedTaxes;
